import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import type { ActionName } from 'src/types';

export interface RightToWorkTrackingData {
  actionName: ActionName;
  rtwCountry: string;
}

export const useUpdateRightsToWorkAnalytics = () => {
  const { updateCard } = useAnalytics();

  const updateRightsToWorkAnalytics = (
    rightToWorkTrackingList: RightToWorkTrackingData[],
  ) => {
    rightToWorkTrackingList.forEach(({ actionName, rtwCountry }) =>
      updateCard({
        actionName,
        currentPageSection: 'next role',
        customProps: {
          currentPageSubsection: 'right to work',
          rtwCountry,
        },
      }),
    );
  };

  return { updateRightsToWorkAnalytics };
};
